module.exports = __webpack_public_path__ + "img/bnr_camplist-s.ced7475a.png";